import React from 'react';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import { Box } from '@mui/material';

const Home = () => {
  return (
    <Box>
      <Hero />
      <Services />
    </Box>
  );
};

export default Home; 